import React, { useEffect, useState } from 'react';
import { Title3, TextLarge } from '@hz-design-system/web-ui';
import { currency } from '@ecg-internal/aurora-js-formatters';
import getBudget from '../repositories/getBudget';

import Classes from './Budget.module.scss';

const PERCENT = 100;
const COMPLETE = 100;

const Budget = () => {
  const [progress, setProgress] = useState(0);
  const [reserved, setReserved] = useState('');
  const [remaining, setRemaining] = useState('');
  const [isBudgetLoading, setIsBudgetLoading] = useState(true);

  useEffect(() => {
    void (async function () {
      const budgetData = await getBudget();
      setProgress((budgetData.reserved / budgetData.budget) * PERCENT);
      setReserved(currency(budgetData.reserved * PERCENT, true, true));
      setRemaining(currency((budgetData.budget - budgetData.reserved) * PERCENT, true, true));
      setIsBudgetLoading(false);
    })();
  }, []);

  return (
    <>
      <div className={Classes.status} id="budget">
        {progress === COMPLETE ? (
          <TextLarge strong>Het hele budget is verleend 🎉</TextLarge>
        ) : (
          <TextLarge strong>{`Nog beschikbaar: ${isBudgetLoading ? '...' : remaining}`}</TextLarge>
        )}
      </div>
      <div className={Classes.barContent}>
        <Title3 as="h2" utilities={['marginBottomL']}>
          Hoeveel budget is er nog over?
        </Title3>
        <div className={Classes.barWrapper}>
          <div className={Classes.barTotal}>
            <div className={Classes.barRemaning} style={{ width: `${progress}%` }} />
          </div>
        </div>
        <div className={Classes.legend}>
          <div className={Classes.legendItem}>
            <span className={Classes.legendItemColor} />
            <span className={Classes.legendItemLabel}>
              Beschikbaar budget: <strong>{remaining}</strong>
            </span>
          </div>
          <div className={Classes.legendItem}>
            <span className={Classes.legendItemColor} />
            <span className={Classes.legendItemLabel}>
              Verleend: <strong>{reserved}</strong>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Budget;
